import React, { useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { ReactComponent as ReplyIcon } from "../../svgs/reply.svg";
import Button from "../Button";
import SellerReply from "./SellerReply";
import SellerMessage from "./SellerMessage";

const AdminReply = ({
  message,
  setChat,
  actionRequired,
  userType = "seller",
  transactionId
}) => {
  const [openSellerForm, setOpenSellerForm] = useState(false);

  let dateObj = new Date(message.created_at);

  const date = dateObj.toLocaleDateString();

  const time = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <div className="py-4 border-b border-gray-500 ">
      <div className="flex ">
        <Avatar size={"large"} icon={<UserOutlined />} />
        <div className="ml-3">
          <div className="flex items-center mb-2">
            <h5 className="text-2xl font-normal">Offsetgo</h5>
            <p className="text-xs text-gray-500 ml-3">{`${date} at ${time}`}</p>
          </div>
          <p className=" text-sm font-medium mb-3">Dear {userType}</p>
          <p className=" text-sm font-medium mb-2">{message.remarks}</p>
          <div>
            {message.document_list.map(({ doc_name }, index) => (
              <div className="flex items-center py-2" key={`docmunts_${index}`}>
                <pre className="text-xs mr-2">{index + 1}.</pre>
                <p className="mr-8 text-xs">{doc_name}*</p>
              </div>
            ))}
            <p className="text-sm font-medium">Thanks and regards</p>
            <p className="text-sm font-medium">Team Offsetgo</p>
          </div>
          {message.isAnswered && (
            <div className="flex flex-col ">
            <div  className="w-fit flex items-center rounded-xl font-medium py-2 px-4 my-2 text-xs bg-blue-300 text-blue-800"  >
            {userType}  reply
              </div>
           <div className="text-sm font-medium ">Dear Admin</div>
            <SellerMessage reply={message?.answer || []} />
            </div>
          )}
          {!message.isAnswered && !openSellerForm && (
            <Button
              onClick={() => setOpenSellerForm(true)}
              color="blue-300"
              varient="primary"
              className="w-fit flex items-center font-medium py-2 px-4 mt-4 text-xs bg-blue-300 text-blue-800"
            >
              <ReplyIcon className="w-4 mr-1" /> send a reply
            </Button>
          )}
          {openSellerForm && (
            <SellerReply
              setChat={setChat}
              actionRequired={actionRequired}
              documents={message?.document_list || []}
              messageId={message?._id}
              onComplete={setOpenSellerForm}
              transactionId={transactionId}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminReply;
